import { render } from "./DropdownMenu.vue?vue&type=template&id=7fa79a3f&scoped=true&ts=true"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts"

import "./DropdownMenu.vue?vue&type=style&index=0&id=7fa79a3f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa79a3f"]])

export default __exports__